import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import {
  Observable,
  catchError,
  from,
  map,
  of,
  switchMap,
  throwError,
} from "rxjs";
import {
  Database,
  equalTo,
  listVal,
  orderByChild,
  query,
  ref,
  push,
  set,
  get,
} from "@angular/fire/database";
import { ITipo } from "../../../interfaces/catalogos.";

@Injectable({
  providedIn: "root",
})
export class TipoService {
  private database: Database = inject(Database);

  cargarTipo(): Observable<ITipo[]> {
    const refCatalogo = ref(this.database, "catalogos/tipo");
    const refQuery = query(refCatalogo, orderByChild("activo"), equalTo(true));
    return listVal(refQuery, { keyField: "id" }).pipe(
      map((tipos: unknown[]) => {
        const _tipos = tipos as ITipo[];
        return _tipos.sort((a, b) =>
          a.descripcion.localeCompare(b.descripcion)
        );
      })
    );
  }

  guardarTipo(descripcion: string): Observable<{ error: boolean }> {
    const refTipo = ref(this.database, "catalogos/tipo");
    const tipoaRef = push(refTipo);
    const nuevoTipo: ITipo = {
      activo: true,
      descripcion: descripcion,
      id: tipoaRef.key || "",
    };

    return from(set(tipoaRef, nuevoTipo)).pipe(
      map(() => ({ error: false })),
      catchError((error) => {
        console.error(error);
        return of({ error: true });
      })
    );
  }

  editarTipo(tipo: ITipo): Observable<{ error: boolean }> {
    const refEmpresa = ref(this.database, `catalogos/tipo/${tipo.id}`);

    return from(get(refEmpresa)).pipe(
      switchMap((empresaSnapshot) => {
        if (empresaSnapshot.exists()) {
          const nuevaEmpresa = empresaSnapshot.val();
          nuevaEmpresa.descripcion = tipo.descripcion;
          return from(set(refEmpresa, nuevaEmpresa)).pipe(
            map(() => ({ error: false })),
            catchError(() => throwError({ error: true }))
          );
        } else {
          return throwError({ error: true });
        }
      }),
      catchError(() => {
        return throwError({ error: true });
      })
    );
  }

  eliminarTipo(id: string): Observable<{ error: boolean }> {
    const refTipoEntrada = ref(this.database, `catalogos/tipo/${id}`);

    return from(get(refTipoEntrada)).pipe(
      switchMap((modoSnapshot) => {
        if (modoSnapshot.exists()) {
          const nuevoTipo = modoSnapshot.val();
          nuevoTipo.activo = false;
          return from(set(refTipoEntrada, nuevoTipo)).pipe(
            map(() => ({ error: false })), // No error
            catchError(() => of({ error: true })) // Error occurred
          );
        } else {
          throw new Error("El tipo no existe.");
        }
      }),
      catchError(() => of({ error: true })) // Error occurred
    );
  }
}
